export function defaultIfUndefined<T>(
  value: T | null | undefined,
  defaultValue: T,
): T | null {
  return value === undefined ? defaultValue : value;
}

export function isNotNullish<T>(value: T | null | undefined): value is T {
  return value != null;
}
